export default {
  zh: {
    userName: '姓名',
    email: '邮件',
    password: '密码',
    department: '部门',
    timeZone: '时区',
    workingHourStart: '上班时间',
    workingHourEnd: '结束时间',
    field_label: '字段标签',
    field_name: 'API',
    layout_name: '布局名',
    section_label: '内容块名',
    field: '字段',
    value: '字段值',
    authenticationMethod: '验证方法',
    mobile: '手机号码',
    none: '无',
    mobileTooltip: '您需要添加一个有效的手机号码才能将手机设置为身份验证方法。',
    countryCode: '国家代码'
  },
  en: {
    userName: 'User Name',
    email: 'Email',
    password: 'Password',
    department: 'Department',
    timeZone: 'Time Zone',
    workingHourStart: 'Working Hour Start',
    workingHourEnd: 'Working Hour End',
    field_label: 'Field Label',
    field_name: 'Field API',
    layout_name: 'Layout Name',
    section_label: 'Section Label',
    field: 'Field',
    value: 'Value',
    authenticationMethod: 'Authentication Method',
    mobile: 'Mobile',
    none: 'None',
    mobileTooltip: 'You need to add a valid mobile number in order to set Mobile as an authentication method.',
    countryCode: 'Country code'
  },
};



// WEBPACK FOOTER //
// ./src/i18n/global/form.js